import { List } from "antd";
import { bankInfoData } from "containers/fundBanks/services/data.transformers";
import { useTranslation } from "react-i18next";

const BanksList = ({ data }) => {
  const { t } = useTranslation();

  const renderListItems = (item) => {
    return (
      <List.Item className="flex justify-between">
        <div className="caption-12px-regular text-gray-0">{item.name}:</div>
        <div>{item.value}</div>
      </List.Item>
    );
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={bankInfoData(data, t)}
      className="border border-gray--6 rounded-lg p-0.5 mt-3"
      renderItem={(item) => renderListItems(item)}
    />
  );
};
export default BanksList;
